import React, { Component } from 'react';
import cx from 'classnames';
import browserHistory from 'react-router/lib/browserHistory';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { connect } from 'react-redux';
import { getLang } from 'redux-pagan';

import appendLocale from '../../helpers/appendLocale';

import * as styles from './NotificationNoCompany.scss';

class NotificationNoCompany extends Component {
  state = {
    closeNotification: false
  }

  closeNotification = () => this.setState({ closeNotification: true });
  goToCreateACompany = () => browserHistory.push(appendLocale(this.props.locale, '/profile/my-company'));

  render() {
    const { translate } = this.props;

    const isCompanyId = get(this.props, 'user.agent_data.agency_id', false);
    const isAgent = get(this.props, 'user.is_agent', false);

    if (!this.state.closeNotification && !isCompanyId && isAgent) {
      return (
          <div className={styles.wrapper}>
          <div className={styles.notification}>
            <span className={cx(styles.iconWrapper, 'icon icon-attention')}>
              <span className="path1" />
              <span className="path2" />
              <span className="path3" />
            </span>
            <p className={styles.title}>
              {translate('notificationNoCompany', 'title')}
            </p>
            <p className={styles.link} onClick={this.goToCreateACompany}>
              {translate('notificationNoCompany', 'link')}
            </p>
          </div>
          <div className={styles.close} onClick={this.closeNotification}>
            <i className="icon icon-close" />
          </div>
        </div>
      );
    }

    return null;
  }
}

NotificationNoCompany.propTypes = {
  locale: PropTypes.string,
  translate: PropTypes.func,
  user: PropTypes.object
};

const mapStateToProps = state => ({
  locale: state.lang.locale,
  translate: getLang(state.lang, 'static'),
  user: state.userAuthentication.data
});

export default connect(mapStateToProps)(NotificationNoCompany);
